import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { TeacherPortfolioRecordTypeEnum } from '@isophi/pap-api';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-portfolio-plan-notes',
    templateUrl: './portfolio-plan-notes.component.html',
    styleUrls: ['./portfolio-plan-notes.component.scss'],
    standalone: false
})
export class PortfolioPlanNotesComponent implements OnInit {
  @Input()
  control!: FormControl;

  @Output()
  requestSave$ = new EventEmitter<string>();

  initValue: string;

  recordTypeEnum = TeacherPortfolioRecordTypeEnum;

  ngOnInit(): void {
    this.initValue = this.control.value;
    this.control.setValidators([Validators.required]);
  }

  cancel(): void {
    this.control.setValue(this.initValue);
  }

  save(): void {
    this.initValue = this.control.value;
    this.requestSave$.emit(this.control.value);
  }
}
